export const DPHI_FOR_TEAMS_ICON = "/organizer/Dphi-for-teams.svg";

export const PATHS_ICON = "/organizer/Paths.png";

export const BILLING_ICON = "/organizer/Billing.png";

export const DPHI_FOR_TEAMS_HOME_ICON = "/organizer/HomeIcon.svg";

export const DPHI_FOR_TEAMS_PATHS_ICON = "/organizer/PathIcon.svg";

export const DPHI_FOR_TEAMS_TEAMS_ICON = "/organizer/TeamsIcon.svg";

export const DPHI_FOR_TEAMS_TEAM_MEMBERS_ICON =
  "/organizer/TeamMembersIcon.svg";

//frontend routes
export const FRONTEND_ORGANIZER_DASHBOARD_URL = "/organizer/dashboard";
export const FRONTEND_ORGANIZER_BILLING_URL = "/organizer/billing";
export const FRONTEND_ORGANIZER_PATHS_URL = "/organizer/paths";
export const FRONTEND_ORGANIZER_SIGNUP_URL = "/accounts/organizer/signup";
export const FRONTEND_ORGANIZER_CHALLENGES_URL = "/organizer/challenges";
export const FRONTEND_ORGANIZER_CREATE_CHALLENGES_URL =
  "/organizer/challenges/create";
